import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { SharedModule } from 'app/shared/shared.module';
import { DoutoradoComponent } from './doutorado.component';
//import { DetalheCursoRedeModule } from './detalhe-curso-rede/detalhe-curso-rede.module';
import { DoutoradoService } from './service/doutorado.service';
import { DetalheCursoModule } from './detalhe-curso/detalhe-curso.module';
import { SharedPosGraduacaoModule } from '../shared/shared-pos-graduacao.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    SharedPosGraduacaoModule,
    //DetalheCursoRedeModule,
    DetalheCursoModule,
  ],
  declarations: [
    DoutoradoComponent,
  ],
  providers: [
    DoutoradoService,
  ],
  exports: [
    DoutoradoComponent,
  ],
})
export class DoutoradoModule { }
